module.exports = __webpack_public_path__ + "static/media/mercadolibre.20035324.svg";